module.exports = __webpack_public_path__ + "static/media/home.616617bd.svg";